import { useState } from 'react';
import { useTranslation } from 'react-i18next';

const WhatsAppButton = () => {
  const { t } = useTranslation();
  const [hovered, setHovered] = useState(false);

  return (
    <a
      href="https://wa.me/966552099231"
      target="_blank"
      rel="nofollow noreferrer"
      aria-label="WhatsApp"
      className="fixed bottom-6 right-6 z-50 flex items-center gap-3 cursor-pointer"
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      {/* Tooltip */}
      <div
        className={`bg-gray-900 text-white text-sm font-medium px-4 py-2 rounded-xl whitespace-nowrap transition-all duration-300 ${
          hovered ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-3 pointer-events-none'
        }`}
      >
        {t('wa.tooltip')}
        <div className="absolute right-[-6px] top-1/2 -translate-y-1/2 w-3 h-3 bg-gray-900 rotate-45"></div>
      </div>

      {/* Button */}
      <div className="relative w-14 h-14 flex items-center justify-center bg-[#25D366] hover:bg-[#1ebe5a] rounded-full transition-all duration-300 hover:scale-110 shadow-lg">
        <i className="ri-whatsapp-line text-white text-2xl"></i>
        {/* Pulse ring */}
        <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-30"></span>
      </div>
    </a>
  );
};

export default WhatsAppButton;
